import React from 'react';

import PlaceHolder from '../component/PlaceHolder';


const MagicHub = () => {
  return <PlaceHolder txt='后台开发中……'/>
};
  
export default MagicHub;